
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forMentionedEntity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLiked"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventObject"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedAdminPost"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedAllocatorProfile"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedCorporateAction"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedEmployerProfile"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedEmployerProfileUpdate"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedFeature"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedIdea"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedIdeaUpdate"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedJobPosting"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedPost"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedPublishedComment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedWhitePaper"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verb"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1278}};
    doc.loc.source = {"body":"#import './ActivityFeedAdminPost.graphql'\n#import './ActivityFeedAllocatorProfile.graphql'\n#import './ActivityFeedCorporateAction.graphql'\n#import './ActivityFeedEmployerProfile.graphql'\n#import './ActivityFeedEmployerProfileUpdate.graphql'\n#import './ActivityFeedFeature.graphql'\n#import './ActivityFeedIdea.graphql'\n#import './ActivityFeedIdeaUpdate.graphql'\n#import './ActivityFeedJobPosting.graphql'\n#import './ActivityFeedPost.graphql'\n#import './ActivityFeedPublishedComment.graphql'\n#import './ActivityFeedWhitePaper.graphql'\n\n#IMPORTANT NOTE: IF YOU ADD A NEW TYPE TO THE EVENT OBJECT UNION, YOU *MUST* ADD THAT TYPE TO THE FRAGMENT MATCHER in client.js.\n#ASK JOE ABOUT THIS IF YOU HAVE QUESTIONS\nfragment ActivityFeedItem on FeedItem {\n  id\n  createdAt\n  forMentionedEntity\n  event {\n    id\n    currentUserHasLiked\n    eventObject {\n      ...ActivityFeedAdminPost\n      ...ActivityFeedAllocatorProfile\n      ...ActivityFeedCorporateAction\n      ...ActivityFeedEmployerProfile\n      ...ActivityFeedEmployerProfileUpdate\n      ...ActivityFeedFeature\n      ...ActivityFeedIdea\n      ...ActivityFeedIdeaUpdate\n      ...ActivityFeedJobPosting\n      ...ActivityFeedPost\n      ...ActivityFeedPublishedComment\n      ...ActivityFeedWhitePaper\n    }\n    likeCount\n    verb\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedAdminPost.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedAllocatorProfile.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedCorporateAction.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedEmployerProfile.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedEmployerProfileUpdate.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedFeature.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedIdea.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedIdeaUpdate.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedJobPosting.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedPost.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedPublishedComment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedWhitePaper.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ActivityFeedItem"] = oneQuery(doc, "ActivityFeedItem");
        
